<div class="country-select-container" (document:click)="onDocumentClick($event)">
  <!-- Input de búsqueda con país seleccionado -->
  <div class="country-select-input-wrapper">
    <ui-molecule-input
      [textId]="textId"
      [placeholder]="placeholder"
      [(ngModel)]="searchQuery"
      (ngModelChange)="onSearchChange($event)"
      (click)="onDropdownToggle()"
      [disabled]="disabled"
      [required]="required"
      class="country-select-input"
    >
    </ui-molecule-input>

    <!-- Botón para limpiar selección -->
    @if (selectedCountry && !disabled) {
      <button
        type="button"
        class="country-select-clear"
        (click)="onClearSelection()"
        aria-label="Clear selection"
      >
        ✕
      </button>
    }

    <!-- Flecha del dropdown -->
    <button
      type="button"
      class="country-select-arrow"
      (click)="onDropdownToggle()"
      [class.open]="isDropdownOpen"
      [disabled]="disabled"
      aria-label="Toggle dropdown"
    >
      ▼
    </button>
  </div>

  <!-- Dropdown con países filtrados -->
  @if (isDropdownOpen && !disabled) {
    <div class="country-select-dropdown">
      @if (filteredCountries.length === 0) {
        <div class="country-select-no-results">No countries found</div>
      } @else {
        <div class="country-select-options">
          @for (country of filteredCountries; track country.code) {
            <div
              class="country-select-option"
              [class.selected]="country.code === selectedCountry"
              (click)="onCountrySelect(country)"
            >
              <span class="country-select-flag">{{ country.flag }}</span>
              <span class="country-select-name">{{ country.name }}</span>
              @if (showDialCode && country.dialCode) {
                <span class="country-select-dial">+{{ country.dialCode }}</span>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
